import { useContext } from "react";

import type { ReactNode } from "react";

import { DBAvailableContext } from "../../contexts/DBAvailableProvider";
import UnderMaintenance from "../UnderMaintenance/UnderMaintenance";

const UnderMaintenanceOrChildren: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { isDBDown } = useContext(DBAvailableContext);

  if (isDBDown) {
    return <UnderMaintenance></UnderMaintenance>;
  }

  return <>{children}</>;
};

export default UnderMaintenanceOrChildren;
